import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from 'antd';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import InfoList from '../InfoList';

const { Title, Paragraph } = Typography;
const aiAnalysisPng = '/home/assets/ai-analysis.png';
const aiAnalysisStyle = {
  '--home-ai-visual-image': `url(${aiAnalysisPng})`,
} as React.CSSProperties;

const aiAnalysisItems = ['aiAnalysis.item.improve', 'aiAnalysis.item.patterns'];

const AiAnalysisSection = () => {
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__split-section home-page__split-section--ai">
      <div
        className="home-page__ai-visual"
        aria-hidden
        style={aiAnalysisStyle}
      />
      <div className="home-page__split-copy">
        <div className="home-page__section-frame">
          <Title level={2}>
            <FormattedMessage id={homeMessageId('aiAnalysis.title')} />
          </Title>
          <Paragraph>
            <FormattedMessage
              id={homeMessageId('aiAnalysis.text')}
              values={{
                highlight: (chunks) => (
                  <span className="home-page__ai-analysis-highlight">
                    {chunks}
                  </span>
                ),
                details: (chunks) => (
                  <span className="home-page__ai-analysis-details">
                    {chunks}
                  </span>
                ),
              }}
            />
          </Paragraph>
          <InfoList items={aiAnalysisItems.map((key) => homeMessageId(key))} />
        </div>
      </div>
    </section>
  );
};

export default AiAnalysisSection;
